/**
 * Flag key constants for use with `useFlags()` from `domains/launchdarkly/hooks`.
 *
 * `monthlyReportsTabVisibile` is misspelled ("Visibile" instead of "Visible") to
 * match the actual key configured in LaunchDarkly. Do not correct the spelling
 * here: doing so would silently break the flag lookup at runtime.
 */
export const FLAGS = Object.freeze({
  portalExperience: 'portalExperience',
  monthlyReportsTabVisibile: 'monthlyReportsTabVisibile',
  overviewChartsVisible: 'overviewChartsVisible',
  experimentalWebComponentsVisible: 'experimentalWebComponentsVisible',
  blockedUser: 'blockedUser',
  dhpMaintenanceUpcoming: 'dhpMaintenanceUpcoming',
  taskActionsVisibleFlag: 'taskActionsVisibleFlag',
  taskNotificationsRandomOptionVisibleFlag:
    'taskNotificationsRandomOptionVisibleFlag',
  duoSsoEnabled: 'duoSsoEnabled',
})
